module.exports = __webpack_public_path__ + "assets/img/default-cover-small.1c6fad1a.png";